import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from './../assets/images/svg/home.svg';
const _withScopeId = n => (_pushScopeId("data-v-1311c02e"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top_game_1"
}, null, -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "van-button__content"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "van-button__text"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  style: {
    "width": "1.5rem"
  }
}), /*#__PURE__*/_createElementVNode("span", {
  class: "item_name"
}, "Home")])], -1));
const _hoisted_3 = [_hoisted_2];
const _hoisted_4 = ["href"];
const _hoisted_5 = {
  class: "van-button van-button--default van-button--normal"
};
const _hoisted_6 = {
  class: "van-button__content"
};
const _hoisted_7 = {
  class: "van-button__text"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "item_name"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createBlock(_component_van_popup, {
    show: $setup.showMenu,
    "onUpdate:show": _cache[1] || (_cache[1] = $event => $setup.showMenu = $event),
    position: "left",
    onClickOverlay: $setup.clickOverlay,
    style: {
      width: '60%',
      height: '100%',
      padding: '0px 0.5rem'
    }
  }, {
    default: _withCtx(() => [_hoisted_1, _createElementVNode("button", {
      class: "van-button van-button--default van-button--normal",
      onClick: _cache[0] || (_cache[0] = (...args) => $setup.goHome && $setup.goHome(...args)),
      style: {
        "padding": "0px 50% 0px 0.002em",
        "border": "unset",
        "box-shadow": "rgba(31, 31, 31, 0.4) 0px 0.1875rem 0.5rem 0px",
        "width": "100%",
        "margin-top": "1rem"
      }
    }, _hoisted_3), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (value, key, index) => {
      return _openBlock(), _createElementBlock("a", {
        href: `./more.html?type=${key}`,
        class: "type_item",
        key: index
      }, [_createElementVNode("button", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, [_createElementVNode("span", null, [_createElementVNode("img", {
        src: value[0].logo,
        style: {
          "width": "1.5rem"
        },
        alt: ""
      }, null, 8, _hoisted_8)]), _createElementVNode("span", _hoisted_9, _toDisplayString(key), 1)])])])], 8, _hoisted_4);
    }), 128))]),
    _: 1
  }, 8, ["show", "onClickOverlay"]);
}